import * as C from '../Constants';

export function fetchAPIData(){
    return function(dispatch){
        dispatch(requestPosts());
        fetch('https://api.covid19india.org/data.json')
        .then(res => res.json())
        .then(stateWiseResp => {
          dispatch(fetchStateDataSuccess(stateWiseResp));
          return stateWiseResp; 
        })
       
    }
}
export const requestPosts = () => ({
    type: C.LOAD_CARD,
    });
export const fetchStateDataSuccess = stateWiseResp => ({
    type: C.LOAD_CARD_SUCCESS,
    stateWiseResp: stateWiseResp,
    });